// prettier-ignore
export default "sz"